<div class="flex items-center">
  <db-svg-icon
    pTooltip="Capacity"
    tooltipPosition="top"
    i18n-pTooltip="@@booking-module|meeting-room-info-icons|capacity"
    path="assets/icons/user-double.svg"
    alt="user-double"
    [class]="['db-icon-lg', 'mr-sm']"
    [attr.data-testId]="'meeting-room-info-icons-capacity'"
  />
  <span class="typography-small">
    {{ roomInfo.capacity }}
  </span>
  @if (roomInfo.accessRules?.isRestricted) {
    <div class="divider"></div>
    <div [pTooltip]="accessRulesTooltipText" tooltipPosition="right" class="flex">
      <db-area-restriction-icon
        [accessRules]="roomInfo.accessRules"
        [isTextGrayIcon]="isTextGrayIcon"
        [withLeftMargin]="withMargin"
        [withRightMargin]="withMargin"
      ></db-area-restriction-icon>
    </div>
  }
  @if (roomInfo.syncProvider === TenantProvider.GOOGLE) {
    <div class="divider"></div>
    <db-svg-icon
      pTooltip="Synced with Google"
      i18n-pTooltip="@@booking-module|meeting-room-info-icons|synced-with-google"
      tooltipPosition="top"
      path="assets/icons/google-gray.svg"
      [class]="['db-icon-lg']"
      alt="google-logo"
      [attr.data-testId]="'meeting-room-info-icons-synced-with-google'"
    />
  } @else if (roomInfo.syncProvider === TenantProvider.MICROSOFT) {
    <div class="divider"></div>
    <db-svg-icon
      pTooltip="Synced with Microsoft"
      i18n-pTooltip="@@booking-module|meeting-room-info-icons|synced-with-microsoft"
      tooltipPosition="top"
      path="assets/icons/microsoft-gray.svg"
      alt="microsoft-logo"
      [class]="['db-icon-lg']"
      [attr.data-testId]="'meeting-room-info-icons-synced-with-microsoft'"
    />
  }
  @if (roomInfo.servicesEnabled.isEnabled) {
    <div class="divider"></div>
    <db-svg-icon
      [pTooltip]="getServicesTooltip(roomInfo.servicesEnabled.categoryNames)"
      tooltipPosition="top"
      i18n-pTooltip="@@booking-module|meeting-room-info-icons|catering"
      path="assets/icons/catering.svg"
      [class]="['db-icon-lg']"
      alt="catering"
      [attr.data-testId]="'meeting-room-info-icons-catering'"
    />
  }
  @if (roomInfo.equipment?.length) {
    <div class="divider"></div>
    <db-svg-icon
      [pTooltip]="getEquipmentTooltip(roomInfo.equipment)"
      path="assets/icons/equipment.svg"
      [class]="['db-icon-lg']"
      alt="equipment"
      [attr.data-testId]="'meeting-room-info-icons-equipment'"
    />
  }
</div>
